import { z } from 'zod';
import type { SchemaType } from '$util/schema';

export const SideBySideColorsSchema = z.object({
  backgroundColor: z.string().optional(),
  titleColor: z.string().optional(),
  subtitleColor: z.string().optional(),
  textColor: z.string().optional(),
  mediaColor: z.string().optional(),
  ctaTextColor: z.string().optional(),
  ctaBackgroundColor: z.string().optional(),
});

export type SideBySideColors = SchemaType<typeof SideBySideColorsSchema>;
